export const DEFERRED_PAYMENT_QUESTION_ID = "deferred-payment";
export const DEFERRED_PAYMENT = {
    questionId: DEFERRED_PAYMENT_QUESTION_ID,
    title: "Odroczona płatność",
    description: "Czy ten klient może zapłacić później, teraz. Pytanie, dla którego system powstał, i jedyne z mierzonym dowodem za swoją regułą.",
};
/** Every question this build answers. Assembled here, not discovered. */
export const QUESTIONS = [DEFERRED_PAYMENT];
export const QUESTION_IDS = QUESTIONS.map((question) => question.questionId);
export function questionOf(questionId) {
    return QUESTIONS.find((question) => question.questionId === questionId);
}
export function isKnownQuestion(value) {
    return QUESTION_IDS.includes(value);
}
//# sourceMappingURL=question.js.map